import SweetAlert from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const ReactSweetAlert = withReactContent(SweetAlert);

export default ReactSweetAlert;
